'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__($thiz, inner) {
  $thiz.vs = inner;
  return $thiz;
}
export { $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__ as $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__ };
/** @constructor */
function $c_ju_Collections$UnmodifiableIterator() {
  this.vs = null;
}
export { $c_ju_Collections$UnmodifiableIterator as $c_ju_Collections$UnmodifiableIterator };
$p = $c_ju_Collections$UnmodifiableIterator.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableIterator() {
}
export { $h_ju_Collections$UnmodifiableIterator as $h_ju_Collections$UnmodifiableIterator };
$h_ju_Collections$UnmodifiableIterator.prototype = $p;
$p.i = (function() {
  return this.vs.i();
});
$p.e = (function() {
  return this.vs.e();
});
$p.rg = (function() {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
var $d_ju_Collections$UnmodifiableIterator = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Collections$UnmodifiableIterator, "java.util.Collections$UnmodifiableIterator", ({
  dO: 1,
  dP: 1,
  bd: 1
}));
export { $d_ju_Collections$UnmodifiableIterator as $d_ju_Collections$UnmodifiableIterator };
